/**
 * Query keys для React Query.
 * Однаковий queryKey = дедуплікація (один активний запит на ключ).
 */

export const queryKeys = {
  credits: ["credits"] as const,
  personalInfo: ["user", "personal-info"] as const,
  profile: (idOrUsername: string) => ["user", "profile", idOrUsername] as const,
  notificationSettings: ["user", "notifications"] as const,
  inAppNotificationsUnreadCount: [
    "user",
    "notifications",
    "in-app",
    "unread-count",
  ] as const,
  subscriptionPlans: ["user", "subscription-plans"] as const,
  /** Для інвалідації всіх user-даних разом */
  user: ["user"] as const,
  /** Creator dashboard (/dashboard) */
  dashboard: {
    main: ["dashboard", "main"] as const,
    earningsTrend: (month: string, year: string) =>
      ["dashboard", "earnings-trend", month, year] as const,
    earningsOverview: (month: string) =>
      ["dashboard", "earnings-overview", month] as const,
    revenue: (year: string) => ["dashboard", "revenue", year] as const,
  },
  /** /admin/moderation — Content Moderation */
  moderation: {
    all: ["moderation"] as const,
    flaggedTab: (filters: {
      status: string;
      severity: string;
      contentType: string;
      sortOrder: string;
    }) => ["moderation", "flagged-tab", filters] as const,
    postReports: (params: Record<string, unknown>) =>
      ["moderation", "post-reports", params] as const,
    profileReports: (params: Record<string, unknown>) =>
      ["moderation", "profile-reports", params] as const,
    commentReports: (params: Record<string, unknown>) =>
      ["moderation", "comment-reports", params] as const,
    appeals: (params: Record<string, unknown>) =>
      ["moderation", "appeals", params] as const,
  },
  /** /admin/platform-kpi */
  admin: {
    platformKpi: ["admin", "platform-kpi"] as const,
  },
} as const;
